import { useRef, useState } from "react";

export const useRowSwipe = (onAction, enabled = true) => {
  const start = useRef(null);
  const dxRef = useRef(0);
  const [drag, setDrag] = useState({ id: null, dx: 0 });

  const handlers = (id) => {
    if (!enabled) return {};
    return {
      onTouchStart: (e) => {
        start.current = { id, x: e.touches[0].clientX, y: e.touches[0].clientY };
        dxRef.current = 0;
      },
      onTouchMove: (e) => {
        if (!start.current || start.current.id !== id) return;
        const dx = e.touches[0].clientX - start.current.x;
        const dy = Math.abs(e.touches[0].clientY - start.current.y);
        if (dy > 45) {
          start.current = null;
          dxRef.current = 0;
          setDrag({ id: null, dx: 0 });
          return;
        }
        if (dx < -8) {
          dxRef.current = Math.max(dx, -130);
          setDrag({ id, dx: dxRef.current });
        }
      },
      onTouchEnd: () => {
        const fire = start.current?.id === id && dxRef.current <= -70;
        start.current = null;
        dxRef.current = 0;
        setDrag({ id: null, dx: 0 });
        if (fire) onAction(id);
      },
    };
  };

  const rowStyle = (id) =>
    drag.id === id
      ? { transform: `translateX(${drag.dx}px)`, transition: "none", background: "rgba(16,185,129,0.10)" }
      : {};

  return { handlers, rowStyle, dragging: drag };
};
